<template>
  <div>
    <link
      href="https://img2.233.com/wx/union/pc/fine/category/css/teacher.css"
      rel="stylesheet"
      type="text/css"
    />
    <div class="wx-header-cont" id="wx-header-cont">
      <!-- 添加white-skin白色皮肤，去掉既黑色皮肤 -->
      <div class="wx-header-container">
        <div class="fl-box">
          <h1 class="logo">
            <a href="/"><img :src="logo" /> </a>
          </h1>
          <div class="line"></div>
          <div class="wx-subject">
            <h2>教师资格</h2>
            <i class="dropdown-arrow"></i>
            <div class="subject-list">
              <a href="/norm/hr">人力资源管理</a>
              <a href="/norm/shgzz">社会工作者</a>
              <a href="/norm/gongzhao">教师公开招聘</a>
              <a href="/norm/teacherms">教师资格面试</a>
              <a href="/channel.aspx?domain=fakao">法律职业资格</a>
            </div>
          </div>
        </div>
        <div class="fr-box">
          <!--未登录 -->
          <div class="personal-no" v-if="!isLogin">
            <p>
              <a :href="'/uc/login?redirecturl=' + href" class="red">登录</a>|<a
                :href="'/uc/register?redirecturl=' + href"
                >注册</a
              >
            </p>
          </div>
          <div class="personal" v-else>
            <a href="javascript:;" class="pic"
              ><img :src="logoSrc"/><i class="dropdown-arrow"></i
            ></a>
            <div class="pop-personal">
              <a href="javascript:" @click="loginout()"
                ><i class="icon"></i><span class="txt">退出</span></a
              >
            </div>
          </div>
          <div class="classify">
            <a
              class="classify-list"
              href="/shopping/cart"
              target="_blank"
              title="购课车"
            >
              <p class="icon shopping"></p>
            </a>
          </div>
          <div v-if="kefu.length > 0" class="wx-telephone">
            <p class="txt1">客服热线</p>
            <p class="txt2">{{ kefu }}</p>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div class="bg-black">
      <!--01banner-->
      <transition name="fade">
        <Banner
          v-show="bannerIndex == 0"
          imgUrl="https://img2.233.com/wx/union/pc/fine/category/img/teacher/banner01.jpg"
        ></Banner>
        <Banner
          v-show="bannerIndex == 1"
          imgUrl="https://img2.233.com/wx/union/pc/fine/category/img/jzs1/banner02.jpg"
        ></Banner>
      </transition>
      <!--01banner 结束-->

      <!---02试听区域--->
      <div class="video clearfix">
        <div class="video-layout">
          <div class="subject-tabBox clearfix">
            <ul class="sub-tabL clearfix">
              <li
                class="line"
                @click="changeCourseIndex(i)"
                v-for="(v, i) in courses.slice(0, 3)"
                :key="i"
              >
                <a
                  href="javascript: void(0)"
                  :class="i == courseIndex ? 'hover' : ''"
                  >{{ v.name }}</a
                >
              </li>
            </ul>
            <div
              class="Rselect-box"
              @mouseover="changeIsHoverCourse(true)"
              @mouseout="changeIsHoverCourse(false)"
            >
              <p class="subject-select currt clearfix">
                <span class="txt">选择其它科目</span><i class="ico"></i>
              </p>
              <div class="sub-sel-list" v-show="isHoverCourse">
                <ul>
                  <li v-for="(v, i) in courses.slice(3)" :key="i">
                    <a
                      @click="changeCourseIndex(i + 3)"
                      style="text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"
                      href="javascript: void(0)"
                      >{{ v.name }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <myvideo
            :isLogin="isLogin"
            :allLoginPlayFlag="allLoginPlayFlag"
            :unionId="unionId"
            :classEname="'teacher'"
            :logo="logo"
            :myClassId="courses[courseIndex].myClassId"
          ></myvideo>
        </div>
        <div class="video-bottom"></div>
      </div>
      <!---02试听区域END--->
    </div>

    <banjiduibi :calssName="'教师资格'" :classEName="'teacher'"></banjiduibi>

    <!--04全部班级表格-->
    <quanbubanji :classEname="'teacher'"></quanbubanji>
    <!--04全部班级表格 end-->
    <!--06套用官网内容  开始------------->
    <!--1老师介绍-->
    <div class="z-teacher">
      <!--标题-->
      <h2 class="w-title w-titleone">
        <span>师资团队</span> <i>集结行内优质师资团队，给你轻松通关的力量</i>
      </h2>
      <!--标题 end-->
      <div class="w-tsubject clearfix">
        <span
          :key="i"
          v-for="(v, i) in laoshijieshao"
          :class="i == laoshiindex ? 'w-tselected' : ''"
          @click="changelaoshiindex(i)"
          >{{ v }}</span
        >
      </div>
      <div class="z-teacherbox" v-if="laoshiindex == 0">
        <div class="z-comment">
          <div class="z-teacher-left">
            <div class="z-qh">
              <span
                :class="laoshidetailindex == 0 ? 'z-msxz' : ''"
                @click="changelaoshidetailindex(0)"
              >
                <i>老师</i>&nbsp;&nbsp;<b>王奕珃</b>
              </span>
              <span
                :class="laoshidetailindex == 1 ? 'z-msxz' : ''"
                @click="changelaoshidetailindex(1)"
              >
                <i>老师</i>&nbsp;&nbsp;<b>牛晶晶</b>
              </span>
            </div>
            <div class="z-teacher-list" v-if="laoshidetailindex == 0">
              <div class="z-laophoto">
                <img
                  src="https://img2.233.com/wx/union/pc/pupage/img/teacher/teacher-01.png"
                  alt="王奕珃"
                />
              </div>
            </div>
            <div class="z-teacher-list" v-if="laoshidetailindex == 1">
              <div class="z-laophoto">
                <img
                  src="https://img2.233.com/wx/union/pc/pupage/img/teacher/teacher-02.png"
                  alt="牛晶晶"
                />
              </div>
            </div>
          </div>
          <div class="z-teacher-right" v-if="laoshidetailindex == 0">
            <div class="z-tname">
              <p class="z-mzname">王奕珃</p>
              <p class="z-legend">自创的考试学理论帮助90%以上学员通过考试</p>
              <p class="z-qualification">
                资&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历：教学经验5年，985名校新闻学硕士，骨干教师
              </p>
              <p class="z-qualification">
                授课特点：深入浅出 妙趣横生 考点分析 简洁明了
              </p>
            </div>
            <div class="z-crbox">
              <h4 class="z-student-re">学员评论<i></i></h4>
              <div class="z-comment-liste js-pinglun">
                <div
                  class="dcc_comment_all"
                  @mousemove="changeIsStop(true)"
                  @mouseout="changeIsStop(false)"
                  ref="comment"
                >
                  <ul class="list-box">
                    <li v-for="(v, i) in wyrevaluate" :key="i">
                      <a href="javascript:;" class="l-head"
                        ><img
                          :src="v.UserPicPath"
                          onerror="javascript:this.src='//img.233.com/wx/img/uc/Avatar2019.png';this.onerror = null"
                      /></a>
                      <span class="speak clearfix">
                        <p class="text one">
                          <font class="bule-color"
                            >{{ v.Location }}:{{ v.IP }}</font
                          ><a href="javascript:;" class="name">{{
                            v.UserName
                          }}</a>
                          <a
                            href="javascript:;"
                            class="ico computer"
                            title="电脑版"
                          ></a>
                        </p>
                        <p class="text two">{{ v.Content }}</p>
                        <p class="text four">
                          <b class="fl">{{ v.EvlDateTime }}</b>
                        </p>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="z-teacher-right" v-if="laoshidetailindex == 1">
            <div class="z-tname">
              <p class="z-mzname">牛晶晶</p>
              <p class="z-legend">长期从事教师资格及招聘考试考题研究</p>
              <p class="z-qualification">
                资&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历：教学经验8年，心理学硕士，教师资格特级讲师
              </p>
              <p class="z-qualification">
                授课特点：教学重难点突出，听完她的课如获利剑，披荆斩棘，水平一流
              </p>
            </div>
            <div class="z-crbox">
              <h4 class="z-student-re">学员评论<i></i></h4>
              <div class="z-comment-liste js-pinglun">
                <div
                  class="dcc_comment_all"
                  @mousemove="changeIsStop(true)"
                  @mouseout="changeIsStop(false)"
                  ref="comment"
                >
                  <ul class="list-box">
                    <li v-for="(v, i) in njjevaluate" :key="i">
                      <a href="javascript:;" class="l-head"
                        ><img
                          :src="v.UserPicPath"
                          onerror="javascript:this.src='//img.233.com/wx/img/uc/Avatar2019.png';this.onerror = null"
                      /></a>
                      <span class="speak clearfix">
                        <p class="text one">
                          <font class="bule-color"
                            >{{ v.Location }}:{{ v.IP }}</font
                          ><a href="javascript:;" class="name">{{
                            v.UserName
                          }}</a>
                          <a
                            href="javascript:;"
                            class="ico computer"
                            title="电脑版"
                          ></a>
                        </p>
                        <p class="text two">{{ v.Content }}</p>
                        <p class="text four">
                          <b class="fl">{{ v.EvlDateTime }}</b>
                        </p>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="z-teacherbox" v-if="laoshiindex == 1">
        <div
          class="z-comment"
          data-type="{cs1:'z-msxz',tlist:'.z-qh span',clist:'.z-teacher-list',clist1:'.z-teacher-right',fun:'getpinglun'}"
          node-type="menu-tab"
        >
          <div class="z-teacher-left">
            <div class="z-qh">
              <span
                :class="laoshidetailindex == 0 ? 'z-msxz' : ''"
                @click="changelaoshidetailindex(0)"
                ><i>老师</i>&nbsp;&nbsp;<b>联盟</b></span
              >
              <span
                :class="laoshidetailindex == 1 ? 'z-msxz' : ''"
                @click="changelaoshidetailindex(1)"
                ><i>老师</i>&nbsp;&nbsp;<b>王奕珃</b></span
              >
              <span
                :class="laoshidetailindex == 2 ? 'z-msxz' : ''"
                @click="changelaoshidetailindex(2)"
                ><i>老师</i>&nbsp;&nbsp;<b>王瑜</b></span
              >
              <span
                :class="laoshidetailindex == 3 ? 'z-msxz' : ''"
                @click="changelaoshidetailindex(3)"
                ><i>老师</i>&nbsp;&nbsp;<b>赵丹</b></span
              >
            </div>
            <div class="z-teacher-list" v-if="laoshidetailindex == 0">
              <div class="z-laophoto">
                <img
                  src="https://img2.233.com/wx/union/pc/pupage/img/teacher/teacher-03.png"
                  alt="联盟"
                />
              </div>
            </div>
            <div class="z-teacher-list" v-if="laoshidetailindex == 1">
              <div class="z-laophoto">
                <img
                  src="https://img2.233.com/wx/union/pc/pupage/img/teacher/teacher-01.png"
                  alt="王奕珃"
                />
              </div>
            </div>
            <div class="z-teacher-list" v-if="laoshidetailindex == 2">
              <div class="z-laophoto">
                <img
                  src="https://img2.233.com/wx/union/pc/pupage/img/teacher/teacher-04.png"
                  alt="王瑜"
                />
              </div>
            </div>
            <div class="z-teacher-list" v-if="laoshidetailindex == 3">
              <div class="z-laophoto">
                <img
                  src="https://img2.233.com/wx/union/pc/pupage/img/teacher/teacher-05.png"
                  alt="赵丹"
                />
              </div>
            </div>
          </div>
          <div class="z-teacher-right " v-if="laoshidetailindex == 0">
            <div class="z-tname">
              <p class="z-mzname">联盟</p>
              <p class="z-legend">累计培训学员一万人以上</p>
              <p class="z-qualification">
                资&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历：教学经验4年，211名校，教育学硕士，高级中学教师资格证
              </p>
              <p class="z-qualification">
                授课特点：上课很有激情，案例贴近生活，通俗易懂，一针见血，抓住考点
              </p>
            </div>
            <div class="z-crbox">
              <h4 class="z-student-re">学员评论<i></i></h4>
              <div class="z-comment-liste js-pinglun">
                <div
                  class="dcc_comment_all"
                  @mousemove="changeIsStop(true)"
                  @mouseout="changeIsStop(false)"
                  ref="comment"
                >
                  <ul class="list-box">
                    <li v-for="(v, i) in lmevaluate" :key="i">
                      <a href="javascript:;" class="l-head"
                        ><img
                          :src="v.UserPicPath"
                          onerror="javascript:this.src='//img.233.com/wx/img/uc/Avatar2019.png';this.onerror = null"
                      /></a>
                      <span class="speak clearfix">
                        <p class="text one">
                          <font class="bule-color"
                            >{{ v.Location }}:{{ v.IP }}</font
                          ><a href="javascript:;" class="name">{{
                            v.UserName
                          }}</a>
                          <a
                            href="javascript:;"
                            class="ico computer"
                            title="电脑版"
                          ></a>
                        </p>
                        <p class="text two">{{ v.Content }}</p>
                        <p class="text four">
                          <b class="fl">{{ v.EvlDateTime }}</b>
                        </p>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="z-teacher-right " v-if="laoshidetailindex == 1">
            <div class="z-tname">
              <p class="z-mzname">王奕珃</p>
              <p class="z-legend">自创的考试学理论帮助90%以上学员通过考试</p>
              <p class="z-qualification">
                资&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历：教学经验5年，985名校新闻学硕士，骨干教师
              </p>
              <p class="z-qualification">
                授课特点：深入浅出 妙趣横生 考点分析 简洁明了
              </p>
            </div>
            <div class="z-crbox">
              <h4 class="z-student-re">学员评论<i></i></h4>
              <div class="z-comment-liste js-pinglun">
                <div
                  class="dcc_comment_all"
                  @mousemove="changeIsStop(true)"
                  @mouseout="changeIsStop(false)"
                  ref="comment"
                >
                  <ul class="list-box">
                    <li v-for="(v, i) in wyrevaluate" :key="i">
                      <a href="javascript:;" class="l-head"
                        ><img
                          :src="v.UserPicPath"
                          onerror="javascript:this.src='//img.233.com/wx/img/uc/Avatar2019.png';this.onerror = null"
                      /></a>
                      <span class="speak clearfix">
                        <p class="text one">
                          <font class="bule-color"
                            >{{ v.Location }}:{{ v.IP }}</font
                          ><a href="javascript:;" class="name">{{
                            v.UserName
                          }}</a>
                          <a
                            href="javascript:;"
                            class="ico computer"
                            title="电脑版"
                          ></a>
                        </p>
                        <p class="text two">{{ v.Content }}</p>
                        <p class="text four">
                          <b class="fl">{{ v.EvlDateTime }}</b>
                        </p>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="z-teacher-right " v-if="laoshidetailindex == 2">
            <div class="z-tname">
              <p class="z-mzname">王瑜</p>
              <p class="z-legend">教师培训行业中的大咖</p>
              <p class="z-qualification">
                资&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历：教学经验8年，汉语言专业，高级教师
              </p>
              <p class="z-qualification">
                授课特点：重难点突出，思路清晰，一针见血的找到关键思路和线索
              </p>
            </div>
            <div class="z-crbox">
              <h4 class="z-student-re">学员评论<i></i></h4>
              <div class="z-comment-liste js-pinglun">
                <div
                  class="dcc_comment_all"
                  @mousemove="changeIsStop(true)"
                  @mouseout="changeIsStop(false)"
                  ref="comment"
                >
                  <ul class="list-box">
                    <li v-for="(v, i) in wyevaluate" :key="i">
                      <a href="javascript:;" class="l-head"
                        ><img
                          :src="v.UserPicPath"
                          onerror="javascript:this.src='//img.233.com/wx/img/uc/Avatar2019.png';this.onerror = null"
                      /></a>
                      <span class="speak clearfix">
                        <p class="text one">
                          <font class="bule-color"
                            >{{ v.Location }}:{{ v.IP }}</font
                          ><a href="javascript:;" class="name">{{
                            v.UserName
                          }}</a>
                          <a
                            href="javascript:;"
                            class="ico computer"
                            title="电脑版"
                          ></a>
                        </p>
                        <p class="text two">{{ v.Content }}</p>
                        <p class="text four">
                          <b class="fl">{{ v.EvlDateTime }}</b>
                        </p>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="z-teacher-right " v-if="laoshidetailindex == 3">
            <div class="z-tname">
              <p class="z-mzname">赵丹</p>
              <p class="z-legend">知识功底深厚，教研室主任</p>
              <p class="z-qualification">
                资&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历：教学经验5年，中南大学文学硕士，重点中学英语老师
              </p>
              <p class="z-qualification">
                授课特点：讲课很有总结性和规律性，知识点阐述通俗易懂，能提高学习兴趣
              </p>
            </div>
            <div class="z-crbox">
              <h4 class="z-student-re">学员评论<i></i></h4>
              <div class="z-comment-liste js-pinglun">
                <div
                  class="dcc_comment_all"
                  @mousemove="changeIsStop(true)"
                  @mouseout="changeIsStop(false)"
                  ref="comment"
                >
                  <ul class="list-box">
                    <li v-for="(v, i) in zdevaluate" :key="i">
                      <a href="javascript:;" class="l-head"
                        ><img
                          :src="v.UserPicPath"
                          onerror="javascript:this.src='//img.233.com/wx/img/uc/Avatar2019.png';this.onerror = null"
                      /></a>
                      <span class="speak clearfix">
                        <p class="text one">
                          <font class="bule-color"
                            >{{ v.Location }}:{{ v.IP }}</font
                          ><a href="javascript:;" class="name">{{
                            v.UserName
                          }}</a>
                          <a
                            href="javascript:;"
                            class="ico computer"
                            title="电脑版"
                          ></a>
                        </p>
                        <p class="text two">{{ v.Content }}</p>
                        <p class="text four">
                          <b class="fl">{{ v.EvlDateTime }}</b>
                        </p>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="z-teacherbox" v-if="laoshiindex == 2">
        <div
          class="z-comment"
          data-type="{cs1:'z-msxz',tlist:'.z-qh span',clist:'.z-teacher-list',clist1:'.z-teacher-right',fun:'getpinglun'}"
          node-type="menu-tab"
        >
          <div class="z-teacher-left">
            <div class="z-qh">
              <span
                :class="laoshidetailindex == 0 ? 'z-msxz' : ''"
                @click="changelaoshidetailindex(0)"
                ><i>老师</i>&nbsp;&nbsp;<b>九九</b></span
              >
              <span
                :class="laoshidetailindex == 1 ? 'z-msxz' : ''"
                @click="changelaoshidetailindex(1)"
                ><i>老师</i>&nbsp;&nbsp;<b>王奕珃</b></span
              >
            </div>
            <div class="z-teacher-list" v-if="laoshidetailindex == 0">
              <div class="z-laophoto">
                <img
                  src="https://img2.233.com/wx/union/pc/pupage/img/teacher/teacher-06.png"
                  alt="九九"
                />
              </div>
            </div>
            <div class="z-teacher-list" v-if="laoshidetailindex == 1">
              <div class="z-laophoto">
                <img
                  src="https://img2.233.com/wx/union/pc/pupage/img/teacher/teacher-01.png"
                  alt="王奕珃"
                />
              </div>
            </div>
          </div>
          <div class="z-teacher-right " v-if="laoshidetailindex == 0">
            <div class="z-tname">
              <p class="z-mzname">九九</p>
              <p class="z-legend">面试主考官，内外兼修的实力女神</p>
              <p class="z-qualification">
                资&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历：教学经验4年，北京师范大学学前教育研究所本科、硕士；幼儿教师资格证，特级教师
              </p>
              <p class="z-qualification">
                授课特点：幽默风趣，生动形象，重点突出，熟悉考题策略，应试型老师
              </p>
            </div>
            <div class="z-crbox">
              <h4 class="z-student-re">学员评论<i></i></h4>
              <div class="z-comment-liste js-pinglun">
                <div
                  class="dcc_comment_all"
                  @mousemove="changeIsStop(true)"
                  @mouseout="changeIsStop(false)"
                  ref="comment"
                >
                  <ul class="list-box">
                    <li v-for="(v, i) in jjevaluate" :key="i">
                      <a href="javascript:;" class="l-head"
                        ><img
                          :src="v.UserPicPath"
                          onerror="javascript:this.src='//img.233.com/wx/img/uc/Avatar2019.png';this.onerror = null"
                      /></a>
                      <span class="speak clearfix">
                        <p class="text one">
                          <font class="bule-color"
                            >{{ v.Location }}:{{ v.IP }}</font
                          ><a href="javascript:;" class="name">{{
                            v.UserName
                          }}</a>
                          <a
                            href="javascript:;"
                            class="ico computer"
                            title="电脑版"
                          ></a>
                        </p>
                        <p class="text two">{{ v.Content }}</p>
                        <p class="text four">
                          <b class="fl">{{ v.EvlDateTime }}</b>
                        </p>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="z-teacher-right " v-if="laoshidetailindex == 1">
            <div class="z-tname">
              <p class="z-mzname">王奕珃</p>
              <p class="z-legend">自创的考试学理论帮助90%以上学员通过考试</p>
              <p class="z-qualification">
                资&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;历：教学经验5年，985名校新闻学硕士，骨干教师
              </p>
              <p class="z-qualification">
                授课特点：深入浅出 妙趣横生 考点分析 简洁明了
              </p>
            </div>
            <div class="z-crbox">
              <h4 class="z-student-re">学员评论<i></i></h4>
              <div class="z-comment-liste js-pinglun">
                <div
                  class="dcc_comment_all"
                  @mousemove="changeIsStop(true)"
                  @mouseout="changeIsStop(false)"
                  ref="comment"
                >
                  <ul class="list-box">
                    <li v-for="(v, i) in wyrevaluate" :key="i">
                      <a href="javascript:;" class="l-head"
                        ><img
                          :src="v.UserPicPath"
                          onerror="javascript:this.src='//img.233.com/wx/img/uc/Avatar2019.png';this.onerror = null"
                      /></a>
                      <span class="speak clearfix">
                        <p class="text one">
                          <font class="bule-color"
                            >{{ v.Location }}:{{ v.IP }}</font
                          ><a href="javascript:;" class="name">{{
                            v.UserName
                          }}</a>
                          <a
                            href="javascript:;"
                            class="ico computer"
                            title="电脑版"
                          ></a>
                        </p>
                        <p class="text two">{{ v.Content }}</p>
                        <p class="text four">
                          <b class="fl">{{ v.EvlDateTime }}</b>
                        </p>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--2授课体系-->
    <div class="z-value">
      <div class="z-main">
        <h2 class="w-title w-titletwo">
          <span>授课体系</span
          ><i>强大教研团队研发科学的授课体系，层层锁分助过关</i>
        </h2>
        <div class="ksndd_bigBox">
          <div class="kqfx_ltTit_box">
            <div class="sub-left">
              <div class="sub-nav-box"></div>
              <div class="sub-tit0">PART</div>
              <div class="sub-tit1">TEACHING SYSTEM</div>
              <div class="sub-tit2">授课体系</div>
            </div>
          </div>
          <div class="ksndd_rtInfo_box">
            <div
              :class="
                hoverindex == 0
                  ? 'ksndd_rtInfo_com ksndd_rtInfo_boxOne this'
                  : 'ksndd_rtInfo_com ksndd_rtInfo_boxOne'
              "
              @mouseover="changehoverindex(0)"
            >
              <div class="sktx-li-hd">
                <div class="sktx-li-bt">01基础阶段</div>
                <div class="sktx-li-sfzs">
                  <em>50<b>%</b></em>
                  <p>提分指数</p>
                </div>
                <div class="decorate">
                  <div class="ball one"></div>
                  <div class="ball two"></div>
                  <div class="ball three"></div>
                  <div class="arrow one"></div>
                  <div class="arrow two"></div>
                  <div class="arrow red"></div>
                </div>
              </div>
              <div class="cl-box">
                <ul>
                  <li>
                    <p></p>
                    <h5>教材精讲班</h5>
                    <p></p>
                    <p>班级作用：全面精讲，锁定核心考点</p>
                  </li>
                  <li>
                    <p></p>
                    <h5>真题全解班</h5>

                    <p></p>
                    <p>班级作用：巩固考点，总结答题“套路”</p>
                  </li>
                </ul>
              </div>
            </div>
            <div
              :class="
                hoverindex == 1
                  ? 'ksndd_rtInfo_com ksndd_rtInfo_boxTwo this'
                  : 'ksndd_rtInfo_com ksndd_rtInfo_boxTwo'
              "
              @mouseover="changehoverindex(1)"
            >
              <div class="sktx-li-hd">
                <div class="sktx-li-bt">02强化阶段</div>
                <div class="sktx-li-sfzs">
                  <em>35<b>%</b></em>
                  <p>提分指数</p>
                </div>
                <div class="decorate">
                  <div class="ball one"></div>
                  <div class="ball two"></div>
                  <div class="ball three"></div>
                  <div class="arrow one"></div>
                  <div class="arrow two"></div>
                  <div class="arrow red"></div>
                </div>
              </div>
              <div class="cl-box">
                <ul>
                  <li>
                    <p></p>
                    <h5>专题班</h5>
                    <p></p>
                    <p>班级作用：专项讲解，短期攻下重难点</p>
                  </li>
                  <li>
                    <p></p>
                    <h5>高频考点班</h5>

                    <p></p>
                    <p>班级作用：冲刺突击，高效备考</p>
                  </li>
                </ul>
              </div>
            </div>
            <div
              :class="
                hoverindex == 2
                  ? 'ksndd_rtInfo_com ksndd_rtInfo_boxThree this'
                  : 'ksndd_rtInfo_com ksndd_rtInfo_boxThree'
              "
              @mouseover="changehoverindex(2)"
            >
              <div class="sktx-li-hd">
                <div class="sktx-li-bt">03冲刺阶段</div>
                <div class="sktx-li-sfzs">
                  <em>15<b>%</b></em>
                  <p>提分指数</p>
                </div>
                <div class="decorate">
                  <div class="ball one"></div>
                  <div class="ball two"></div>
                  <div class="ball three"></div>
                  <div class="arrow one"></div>
                  <div class="arrow two"></div>
                  <div class="arrow red"></div>
                </div>
              </div>
              <div class="cl-box">
                <ul>
                  <li>
                    <p></p>
                    <h5>考题突击班</h5>
                    <p></p>
                    <p>班级作用：考前摸底检测，内部锁分</p>
                  </li>
                  <li>
                    <p></p>
                    <h5>真题解析班</h5>

                    <p></p>
                    <p>班级作用：总结考题规律，预测考点</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--考证好处-->
    <div class="z-nine">
      <h2 class="w-title w-titleone">
        <span>教师资格证的超实用好处</span
        ><i>一定要考！九大超实用好处等你享！</i>
      </h2>
      <div class="z-nine-bg">
        <div class="nine-box">
          <ul>
            <li>
              <div class="drag" node-type="drag">
                <div class="bg"></div>
                <div class="c">
                  <p>
                    教师工资不低于公务员，待遇稳定，福利有保障，教师拥有“双休”加寒暑假的超长假期，教师工作环境也相比其他职业更舒适，无论软件、硬件、基础设施还是室内外环境。
                  </p>
                </div>
              </div>
              <div class="title">
                <b>TEACHER WELFARE</b>
                <h2>教师待遇好福利多</h2>
                <p>教师工资不低于公务员，带薪寒暑假令人向往。</p>
              </div>
            </li>
            <li>
              <div class="drag" node-type="drag">
                <div class="bg"></div>
                <div class="c">
                  <p>
                    社会要弘扬尊师重教的社会风尚，努力提高教师政治地位、社会地位、职业地位，让广大教师享有应有的社会声望，在教书育人岗位上为党和人民事业作出新的更大的贡献。
                  </p>
                </div>
              </div>
              <div class="title">
                <b>TEACHER WELFARE</b>
                <h2>教师社会地位逐年提高</h2>
                <p>教师工作性质稳定，社会地位高。</p>
              </div>
            </li>
            <li>
              <div class="drag" node-type="drag">
                <div class="bg"></div>
                <div class="c">
                  <p>
                    教师管理制度逐渐完善；激励措施：提升待遇，重点扶持乡村教师；高校教师队伍规范：教师职称监管加强；教师法新规定明确要求要保护教师的合法权益，提高薪资水平。
                  </p>
                </div>
              </div>
              <div class="title">
                <b>TEACHER WELFARE</b>
                <h2>教师未来发展前景不错</h2>
                <p>国家政策利好，重点扶持乡村教师。</p>
              </div>
            </li>
            <li>
              <div class="drag" node-type="drag">
                <div class="bg"></div>
                <div class="c">
                  <p>
                    在编教师、特岗教师、三支一扶中的支教、私立学校、教育机构公务员大学生服务西部计划。总之，考一张教师资格证，可以敲开这六大职业的大门。
                  </p>
                </div>
              </div>
              <div class="title">
                <b>TEACHER WELFARE</b>
                <h2>找工作的加分项</h2>
                <p>教师资格证可敲开这六大职业的大门</p>
              </div>
            </li>
            <li>
              <div class="drag" node-type="drag">
                <div class="bg"></div>
                <div class="c">
                  <p>
                    生育高峰带动教师走俏，教育培训迎来发展高峰。未来将有更多的教育需求缺口。体现在两方面，一是基础公立学校教职员人才的空缺，二是校外素质教育教职人才的空缺。
                  </p>
                </div>
              </div>
              <div class="title">
                <b>TEACHER WELFARE</b>
                <h2>教师行业需求量倍增</h2>
                <p>教师的行业缺口进一步扩大</p>
              </div>
            </li>
            <li>
              <div class="drag" node-type="drag">
                <div class="bg"></div>
                <div class="c">
                  <p>
                    当教师的必要条件之一就是必须要有教师资格证，只有考上教师资格证，才有资格从事教师这份职业。教师资格证不仅仅是敲门砖，也是真正让你受益终身的知识技能。
                  </p>
                </div>
              </div>
              <div class="title">
                <b>TEACHER WELFARE</b>
                <h2>从业敲门砖</h2>
                <p>教师资格证是从事教育工作的敲门砖</p>
              </div>
            </li>
            <li>
              <div class="drag" node-type="drag">
                <div class="bg"></div>
                <div class="c">
                  <p>
                    拥有教师资格证书，在考公务员或面试大企业的时候更有优势。有证书说明在语言能力不错，很多企业更青睐有证人。持证旅游、乘车可以半票或免票；教师节乘车免费等优惠政策。
                  </p>
                </div>
              </div>
              <div class="title">
                <b>TEACHER WELFARE</b>
                <h2>证书性价比高</h2>
                <p>考试费用低，含金量高</p>
              </div>
            </li>
            <li>
              <div class="drag" node-type="drag">
                <div class="bg"></div>
                <div class="c">
                  <p>
                    非师范类的考生允许参加考试，报考并不限制专业，年龄限制范围很大，只要是国家承认的学历，大专、本科、函授、网络教育等考生都可以找到自己能报考的教师资格证学段。
                  </p>
                </div>
              </div>
              <div class="title">
                <b>TEACHER WELFARE</b>
                <h2>门槛低，且难度不大</h2>
                <p>报考条件宽松，年龄、学历条件要求不高</p>
              </div>
            </li>
            <li>
              <div class="drag" node-type="drag">
                <div class="bg"></div>
                <div class="c">
                  <p>
                    根据个税法规定，通过考试并获得相关证书，当年按照3600元定额扣除
                  </p>
                </div>
              </div>
              <div class="title">
                <span class="title-new">新</span><b>TEACHER WELFARE</b>
                <h2>个税补贴</h2>
                <p>
                  根据个税法规定，通过考试并获得相关证书，当年按照3600元定额扣除
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--考证对比-->
    <div class="z-compar z-compar-dbbg clearfix">
      <h2 class="w-title w-titleone">
        <span>培训对比</span><i>网校特色教学，你不想通关都很难</i>
      </h2>
      <div class="z-main z-training">
        <div class="z-main-con">
          <ul>
            <li>
              <h5>选择裸考</h5>
            </li>
            <li class="con-001">
              <b>01</b>
              <p>
                <em>自律性差，决心不够：</em
                >自学考生抱着试一试态度，三分钟热度，考前变成裸考。
              </p>
            </li>
            <li class="con-002">
              <b>02</b>
              <p>
                <em>花费时间较多，效率低，成本高：</em
                >考点知识掌握不透，而且遇到不会的问题时，也很难得到解决。这样的话，遗留的问题越来越多，尤其上班族备考时间少，工作的压力大，身体、精神都负荷不了。
              </p>
            </li>
            <li class="con-002">
              <b>03</b>
              <p>
                <em>应试经验不足：</em
                >初次报考人群对考试流程、考试题目不了解，掌握不了重点。
              </p>
            </li>
            <li class="con-002">
              <b>04</b>
              <p>
                <em>缺乏学习计划和复习规划：</em
                >零基础考生专业知识欠缺，对备考了解太少，而且自学遇到了问题，也很难找到人帮助解决。
              </p>
            </li>
            <li class="con-002">
              <b>05</b>
              <p>
                <em>专业性强准备不足：</em
                >专业科目的考试，尤其面试，备考时间短，常规备考很容易准备不足。
              </p>
            </li>
          </ul>
        </div>
        <div class="z-main-con font-two">
          <ul>
            <li>
              <h5>选择网校备考</h5>
            </li>
            <li class="con-001">
              <b>01</b>
              <p>
                <em>有效解决许多考生自制力差的情况：</em
                >专业辅导可以对考生的行为起到一定的监管作用，提供随时交流的平台，学习的内容当场消化。
              </p>
            </li>
            <li class="con-002">
              <b>02</b>
              <p>
                <em>免费的备考平台，优化你的学习成本：</em
                >网校提供了历年考情，考试信息和丰富的备考资料，收获满满。
              </p>
            </li>
            <li class="con-002">
              <b>03</b>
              <p>
                <em>制定合理的学习方法和备考计划，学习时间缩短：</em
                >专业的辅导有效把控复习进度，合理安排复习计划。为考生提供清晰有序的学习方法，把握学习方向。
              </p>
            </li>
            <li class="con-002">
              <b>04</b>
              <p>
                <em>吃透重难点，提高学习效率：</em
                >专业辅导能够更快理解教材中的难、重点部分，根据试题讲解，提供及时高效的考题信息，做到有针对性复习。
              </p>
            </li>
            <li class="con-002">
              <b>05</b>
              <p><em>面试专业性很强：</em>面试专业性强需要现场模拟练习。</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--06套用官网内容  end------------->
    <!--05服务特色标题-->
    <div class="main-title f-tac m-b-30 p-t-50">
      <p class="font-bg">CHARACTERISTIC</p>
      <h2 class="font44 fb">选择我们的<em class="text-red fb">四大理由</em></h2>
      <p class="font17 text-gry-6 lh2">服务保障，学习无忧，通关指日可待</p>
    </div>
    <div class="fuwu-bg bg-qgry">
      <div class="fuwu-content">
        <div class="fuwu-box">
          <ul class="clearfix m-b-20">
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">1</span>课程品质高
              </h4>
              <p class="font15 lh2 p-15">
                课程专业的教研团队精心打造，<em class="text-red fb"
                  >每个课程均经过20+次以上迭代</em
                >。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">2</span>老师实力强
              </h4>
              <p class="font15 lh2 p-15">
                网校执行严格的<em class="text-red fb"
                  >师资淘汰制，由购课学员评分</em
                >，努力建设零差评老师团队。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">3</span>学习服务优
              </h4>
              <p class="font15 lh2 p-15">
                您在学习课程中遇到任何问题，可在线提问，专业老师<em
                  class="text-red fb"
                  >24小时内为您答疑解惑</em
                >。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">4</span>售后服务好
              </h4>
              <p class="font15 lh2 p-15">
                部分套餐课程享<em class="text-red fb">超长有效期</em
                >，课程有效期内考试<em class="text-red fb">不过免费重学</em
                >保障。
              </p>
            </li>
          </ul>
        </div>

        <!--新人礼包-->
        <div class="new-gift " style="display: none;">
          <div class="gift-box f-tac clearfix">
            <h4 class="font26 fb  m-t-30 m-b-20">
              还没选好哪个班？已为您奉上一份<em class="text-red  fb"
                >新人大礼包</em
              >！
            </h4>
            <p class="text-red font18">
              学习备考资料 + 免费视频课程 + 600元购课优惠券<a
                href=""
                class="btn-redbg font20 fb "
                >免费领取<i></i
              ></a>
            </p>
          </div>
        </div>
        <!--新人礼包 end-->
      </div>
    </div>
    <!--05服务特色 end-->
  </div>
</template>
<script>
import banjiduibi from "@/components/banjiduibi";
import quanbubanji from "@/components/quanbubanji";
import myvideo from "@/components/myvideo";

import { getEvaluateByTeacher } from "@/request/request.js";
import { getMemberPicpath } from "@/request/request.js";
export default {
  name: "App",
  components: {
    banjiduibi,
    quanbubanji,
    myvideo,
  },
  data() {
    return {
      isLogin: false,
      logoSrc: "",
      allLoginPlayFlag: false,
      unionId: "",
      bannerIndex: 0,
      kefu: "",
      logo: "",
      href: "",
      laoshijieshao: ["小学", "中学", "幼儿"],
      laoshiindex: 0,
      laoshidetailindex: 0,
      hoverindex: 1,
      teacherIds: [
        [804, 628],
        [934, 804, 989, 995],
        [938, 804],
      ],
      wyrevaluate: [],
      njjevaluate: [],
      lmevaluate: [],
      wyevaluate: [],
      zdevaluate: [],
      jjevaluate: [],
      courses: [
        { name: "初中语文学科知识与教学能力", myClassId: 30314 },
        { name: "初中英语学科知识与教学能力", myClassId: 30316 },
        { name: "初中音乐学科知识与教学能力", myClassId: 30318 },
        { name: "高中语文学科知识与教学能力", myClassId: 30319 },
        { name: "高中数学学科知识与教学能力", myClassId: 30320 },
        { name: "高中英语学科知识与教学能力", myClassId: 30321 },
        { name: "初中数学学科知识与教学能力", myClassId: 30315 },
        { name: "《幼儿综合素质》", myClassId: 30324 },
        { name: "《幼儿保教知识与能力》", myClassId: 30325 },
        { name: "《小学教育教学知识与能力》", myClassId: 30311 },
        { name: "《中学综合素质》", myClassId: 30312 },
        { name: "《中学教育知识与能力》", myClassId: 30313 },
        { name: "《小学综合素质》", myClassId: 30310 },
        { name: "高中音乐学科知识与教学能力", myClassId: 30323 },
        { name: "初中美术学科知识与教学能力", myClassId: 30317 },
        { name: "高中美术学科专业知识", myClassId: 30322 },
      ],
      courseIndex: 0,
      isHoverCourse: false,
      now: 0,
      height: 0,
      isStop: false,
    };
  },
  created() {
    this.href = encodeURIComponent(window.location.href);
    this.getEvaluateByTeacher(
      this.teacherIds[this.laoshiindex][this.laoshidetailindex]
    );
    var config = JSON.parse(
      sessionStorage.getItem(window.location.host + "puconfig")
    );
    if (config.KefuTelList.length > 0) {
      this.kefu = config.KefuTelList[0].KefuNumber;
    }
    this.unionId = config.UnionId;
    this.logo = config.UnionLogo;
    this.allLoginPlayFlag = config.AllLoginPlayFlag;
    setInterval(() => {
      this.bannerIndex = this.bannerIndex == 1 ? 0 : 1;
    }, 5000);

    var token = localStorage.getItem("usertoken");
    if (token != undefined) {
      this.isLogin = true;
      getMemberPicpath({}, (res) => {
        this.logoSrc = res;
      });
    } else {
      var interval = setInterval(() => {
        token = localStorage.getItem("usertoken");
        if (token != undefined) {
          this.isLogin = true;
          getMemberPicpath({}, (res) => {
            this.logoSrc = res;
          });
          clearInterval(interval);
        }
      }, 200);
    }

    this.now = 0;
    let timer = setInterval(() => {
      if (
        this.$refs.comment.offsetHeight > 0 &&
        this.$refs.comment.offsetHeight != 200
      ) {
        this.height = this.$refs.comment.offsetHeight - 200;
        clearInterval(timer);
      }
    }, 100);
    setInterval(() => {
      if (this.now >= this.height) {
        this.now = 0;
      }
      if (!this.isStop) {
        this.now += 1;
        this.$refs.comment.style.marginTop = "-" + this.now + "px";
      }
    }, 30);
  },
  methods: {
    loginout() {
      this.isLogin = false;
      this.logoSrc = "";
      localStorage.removeItem("usertoken");
    },
    changeIsStop(flag) {
      this.isStop = flag;
    },
    changeCourseIndex(i) {
      this.courseIndex = i;
    },
    changeIsHoverCourse(flag) {
      this.isHoverCourse = flag;
    },
    changelaoshiindex(i) {
      this.laoshidetailindex = 0;
      this.laoshiindex = i;
      this.getEvaluateByTeacher(
        this.teacherIds[this.laoshiindex][this.laoshidetailindex]
      );
      this.now = 0;
      let timer = setInterval(() => {
        if (
          this.$refs.comment.offsetHeight > 0 &&
          this.$refs.comment.offsetHeight != 200
        ) {
          this.height = this.$refs.comment.offsetHeight - 200;
          clearInterval(timer);
        }
      }, 100);
    },
    changelaoshidetailindex(i) {
      this.laoshidetailindex = i;
      this.getEvaluateByTeacher(
        this.teacherIds[this.laoshiindex][this.laoshidetailindex]
      );
      this.now = 0;
    },
    changehoverindex(i) {
      this.hoverindex = i;
    },
    getEvaluateByTeacher(teacherId) {
      if (teacherId == 804 && this.wyrevaluate.length == 0) {
        getEvaluateByTeacher({ teacherId: teacherId }, (res) => {
          this.wyrevaluate = res;
        });
      } else if (teacherId == 628 && this.njjevaluate.length == 0) {
        getEvaluateByTeacher({ teacherId: teacherId }, (res) => {
          this.njjevaluate = res;
        });
      } else if (teacherId == 934 && this.lmevaluate.length == 0) {
        getEvaluateByTeacher({ teacherId: teacherId }, (res) => {
          this.lmevaluate = res;
        });
      } else if (teacherId == 989 && this.wyevaluate.length == 0) {
        getEvaluateByTeacher({ teacherId: teacherId }, (res) => {
          this.wyevaluate = res;
        });
      } else if (teacherId == 995 && this.zdevaluate.length == 0) {
        getEvaluateByTeacher({ teacherId: teacherId }, (res) => {
          this.zdevaluate = res;
        });
      } else if (teacherId == 938 && this.jjevaluate.length == 0) {
        getEvaluateByTeacher({ teacherId: teacherId }, (res) => {
          this.jjevaluate = res;
        });
      }
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
  opacity: 0;
}
</style>
